<template>
    <div class="left xl:pr-spc19 lg:pr-spc19 pr-spc19 md:pr-spc2 xl:pt-20 lg:pt-20 pt-20 md:pt-0 xl:pl-0 lg:pl-0 md:pl-spc2 w-full ">
        <SectionHeading title="How our Delivery Software works?" content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna" contentclass="max-w-370px" />

        <div class="hiw-accordion text-white xl:mt-spc21 lg:mt-spc21 mt-spc21 md:mt-spc63">
            <HiwAccordion :accordionitem="accordionData" />
        </div>
    </div>
</template>

<script>
    import SectionHeading from "../../../common/SectionHeading";
    import HiwAccordion from "../../../common/HiwAccordion";


    let accordionData = {
        accordionLists: [
            {
                title: "Store Assigns Delivery to Driver",
                content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna."
            },
            {
                title: "Your Store Receives An Order",
                content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna."
            },
            {
                title: "Driver Receives Delivery & Updates Store & Customer",
                content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna."
            },
            {
                title: "Driver Delivers Package To Customer",
                content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna."
            },
        ]
    }

    export default {
        name: "HowItWorkLeft",
        components: {
            HiwAccordion,
            SectionHeading
        },
        data() {
            return {
                accordionData
            }
        }
    }
</script>

<style scoped>

</style>